import type { Period } from '@weft/types';
import type { Optional } from '@weft/utils';
import { isNullOrUndefined } from '@weft/utils';
import { dayjs, isEmptyString } from '@weft/utils';
import { useDownloadPdfBlob } from './use-download-pdf-blob';

export function useDownloadInvoicePdf(encodedPdf: Optional<string>, invoiceId: string | undefined, customerName: string | undefined, invoiceBillingCycle: Period | undefined) {
  const downloadPdfBlob = useDownloadPdfBlob();

  return () => {
    if (isEmptyString(encodedPdf) || isEmptyString(invoiceId) || isEmptyString(customerName) || isNullOrUndefined(invoiceBillingCycle)) {
      return;
    }

    const fileName = `${customerName} ${dayjs(invoiceBillingCycle.startTime).format('(MM-YY)')} - Invoice ${invoiceId.slice(-5)}`;

    downloadPdfBlob(encodedPdf, fileName);
  };
}